import { TextInput, Box, Accordion } from "@mantine/core";
import React from "react";
import { ArrowLeft } from "tabler-icons-react";
import { ItemProps, ReportComponentName, ReportInfo } from "../../../../../types/types";
import "./Item.css";

const handleChange = (
  event: any,
  reportInfo: ReportInfo,
  setReportInfo: any
) => {
  const columnName = event.target.name;
  const headerValue = event.target.value;
  reportInfo.extendedAttributes.headers[columnName] = headerValue;
  setReportInfo(reportInfo);
};


const Item: React.FC<ItemProps> = ({ text, index, id, ...props }: any) => {
  //if user clicks on item from query_column, the item gets deleted from query_column list and gets added to report_column list and vice versa
  const Columns = (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.columnsViewReport : props.columns;
  const changeColumn = (id: string) => {
    //creates a copy of the column state
    let updatedColumns = { ...Columns };
    addColumnsInRequestBody(updatedColumns, id, index);
    if (id === "Query_Columns") {
      const removedElement = Columns["Query_Columns"].list.splice(
        index,
        1
      );
      updatedColumns["Report_Columns"].list.push(removedElement);
    } else {
      const removedElement = Columns["Report_Columns"].list.splice(
        index,
        1
      );
      updatedColumns["Query_Columns"].list.push(removedElement);
    }
    props.currentReportComponent === "viewReport" ? props.setColumnsViewReport(updatedColumns) : props.setColumns(updatedColumns);
    props.setReportState((currentState: any) => ({
      ...currentState,
      validationErrors: currentState.validationErrors.filter(
        (er: any) => er.property !== "simpleReportError"
      ),
    }));
  };



  //for download report
  const addColumnsInRequestBody = (object: any, id: any, index: number) => {
    let copyOfReportInfo = { ...props.reportInfo };
    if (!props.reportInfo.extendedAttributes) {
      copyOfReportInfo.extendedAttributes = { headers: {} };
    }
    if (id === "Query_Columns") {
      let columnName = object[id]["list"][index];
      copyOfReportInfo.extendedAttributes.headers[columnName] = columnName;
    } else {
      let columnName = object[id]["list"][index];
      delete copyOfReportInfo.extendedAttributes.headers[columnName];
    }

    props.setReportInfo(copyOfReportInfo);
  };

  return (
    <div
      className="item"
      //on clicking on the item from query_column call changeColumn function
      onClick={() => id === "Query_Columns" && changeColumn(id)}
    >
      {/* for the items in report_columns , an arrow appears in the div and AccordianRow is called that handles the header input */}
      {id === "Report_Columns" && (
        <Box
          sx={() => ({
            display: "flex",
          })}
        >
          <ArrowLeft
            onClick={(e) => {
              e.stopPropagation();
              changeColumn(id);
            }}
            size={24}
            strokeWidth={2}
            color={"black"}
          />
          <AccordionRow text={text} {...props} />
        </Box>
      )}

      {id === "Query_Columns" && <div>{text}</div>}
    </div>
  );
};

const AccordionRow = (props: any) => {
  
  return (
    <Accordion iconPosition="right" transitionDuration={500}>
      <Accordion.Item label={props.text}>
        <TextInput
          name={props.text}
          onChange={(e) =>
            handleChange(e, { ...props.reportInfo }, props.setReportInfo)
          }
          // value={(props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.extendedAttributesViewReports.headers[props.text] : props.reportInfo.extendedAttributes.headers[props.text]}
          value={props.reportInfo.extendedAttributes.headers[props.text]}
          placeholder="Header"
          label="Header"
        />
      </Accordion.Item>
    </Accordion>
  )
};

export default Item;
